import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
	providedIn: 'root',
})
export class SnackbarService {
	private snackBar = inject(MatSnackBar);
	private readonly translocoService = inject(TranslocoService);

	/** Zeigt eine Fehlermeldung; ergänzt sie um ein aus der API-Antwort extrahiertes Detail (falls vorhanden). */
	apiError(error: unknown, message: string, duration: number = 60000, action: string = 'Ok') {
		const detail = this.extractErrorDetail(error);
		this.error(detail ? `${message}: ${detail}` : message, duration, action);
	}

	private extractErrorDetail(error: unknown): string | null {
		const body = (error as { error?: { errorDetails?: Record<string, string>; errorDescription?: { errorDetails?: Record<string, string> } } })?.error;
		// aktuelles Format: { errorDetails: { de, en } } — Legacy-Format: { errorDescription: { errorDetails: { de, en } } }
		const details = body?.errorDetails ?? body?.errorDescription?.errorDetails;
		if (!details) {
			return null;
		}
		const lang = this.translocoService.getActiveLang();
		return details[lang] ?? details['de'] ?? Object.values(details).at(0) ?? null;
	}

	error(message: string, duration: number = 60000, action: string = 'Ok') {
		this.snackBar.open(message, action, {
			duration: duration,
			panelClass: ['error-snackbar'],
		});
	}

	success(message: string, duration: number = 6000, action: string = 'Ok') {
		this.snackBar.open(message, action, {
			duration: duration,
			panelClass: ['success-snackbar'],
		});
	}

	warn(message: string, duration: number = 6000, action: string = 'Ok') {
		this.snackBar.open(message, action, {
			duration: duration,
			panelClass: ['warn-snackbar'],
		});
	}

	noduration(message: string) {
		this.snackBar.open(message, '', {
			panelClass: ['success-snackbar'],
		});
	}
}
